import type React from "react";
import { useCallback, useState } from "react";
import Marquee from "react-fast-marquee";
import styles from "src/components/elements/MarqueeLiveTitle/marqueeLiveTitle.module.css";

type MarqueeLiveTitleProps = {
    liveTitle: string;
    limit: number;
};

const MarqueeLiveTitle: React.FunctionComponent<MarqueeLiveTitleProps> = (
    props
) => {
    const [playBool, setPlayBool] = useState(true);

    const CycleComplete = useCallback(() => {
        setPlayBool(false);
        setTimeout(() => {
            setPlayBool(true);
        }, 3000);
    }, []);

    if (props.liveTitle.length > props.limit) {
        return (
            <Marquee
                speed={30}
                delay={2}
                onCycleComplete={CycleComplete}
                play={playBool}
                className={styles.live_title_container}
            >
                <p className={styles.live_title}>{props.liveTitle}</p>
            </Marquee>
        );
    }

    return (
        <div className={styles.live_title_container}>
            <p className={styles.live_title}>{props.liveTitle}</p>
        </div>
    );
};

export default MarqueeLiveTitle;
